import React, { Component } from 'react'

export default class PaginatorPageGap extends Component {
  shouldComponentUpdate() {
    return false
  }

  render() {
    return <span data-qv-pagination="page gap">...</span>
  }
}



// WEBPACK FOOTER //
// ../src/components/PaginatorPageGap.js